/* Carrinho lateral NutriCaps — abre ao adicionar produto e ao clicar no ícone do carrinho. */
(function () {
  'use strict';

  var drawer = document.querySelector('[data-cart-drawer]');
  if (!drawer) return;

  var itemsEl = drawer.querySelector('[data-cd-items]');
  var emptyEl = drawer.querySelector('[data-cd-empty]');
  var footerEl = drawer.querySelector('[data-cd-footer]');
  var subtotalEl = drawer.querySelector('[data-cd-subtotal]');
  var countEl = drawer.querySelector('[data-cd-count]');
  var noticeEl = drawer.querySelector('[data-cd-notice]');
  var errorEl = drawer.querySelector('[data-cd-error]');
  var checkoutEl = drawer.querySelector('[data-cd-checkout]');
  var isCartPage = document.body.classList.contains('template-cart');
  var lastCount = null;
  var closeTimer = null;

  var fmt = new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' });
  function money(cents) { return fmt.format((cents || 0) / 100); }
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function cleanVariant(t) {
    if (!t || t === 'Default Title') return '';
    return t
      .replace(/MAIS[ _]POPULAR|MELHOR CUSTO-BENEF[IÍ]CIO|MELHOR CUSTO|MAIOR ECONOMIA/gi, '')
      .replace(/^[\s\-–—]+|[\s\-–—]+$/g, '')
      .trim();
  }
  function thumb(url) {
    if (!url) return '';
    return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=160';
  }
  function jsonOrThrow(r) {
    return r.json().then(function (d) { if (!r.ok) throw d; return d; });
  }

  /* ---------- Badge do carrinho no cabeçalho ---------- */
  function ensureBadge() {
    var b = document.querySelector('[data-cart-count]');
    if (b) return b;
    var cartLink = document.querySelector('.site-header__cart');
    if (!cartLink) return null;
    b = document.createElement('span');
    b.className = 'cart-count-badge';
    b.setAttribute('data-cart-count', '');
    b.setAttribute('aria-label', 'Itens no carrinho');
    b.hidden = true;
    cartLink.appendChild(b);
    return b;
  }
  function setCount(n) {
    var b = ensureBadge();
    if (!b) return;
    b.textContent = n > 99 ? '99+' : String(n);
    b.hidden = !(n > 0);
    if (lastCount !== null && n !== lastCount && n > 0) {
      b.classList.remove('is-bumping');
      void b.offsetWidth;
      b.classList.add('is-bumping');
    }
    lastCount = n;
  }

  /* ---------- Render ---------- */
  function render(cart) {
    setCount(cart.item_count);
    countEl.textContent = cart.item_count ? '(' + cart.item_count + ')' : '';

    if (!cart.items || !cart.items.length) {
      itemsEl.innerHTML = '';
      emptyEl.hidden = false;
      footerEl.hidden = true;
      noticeEl.hidden = true;
      return cart;
    }
    emptyEl.hidden = true;
    footerEl.hidden = false;

    itemsEl.innerHTML = cart.items.map(function (it) {
      var v = cleanVariant(it.variant_title);
      var old = it.original_line_price > it.final_line_price ? '<s>' + money(it.original_line_price) + '</s>' : '';
      return '' +
        '<li class="cd-item" data-key="' + esc(it.key) + '" data-qty="' + it.quantity + '">' +
          '<a href="' + esc(it.url) + '" class="cd-item__img">' +
            (it.image ? '<img src="' + esc(thumb(it.image)) + '" alt="" loading="lazy" width="72" height="72">' : '') +
          '</a>' +
          '<div class="cd-item__info">' +
            '<a href="' + esc(it.url) + '" class="cd-item__title">' + esc(it.product_title) + '</a>' +
            (v ? '<p class="cd-item__variant">' + esc(v) + '</p>' : '') +
            '<div class="cd-item__row">' +
              '<div class="cd-qty">' +
                '<button type="button" data-cd-qty="-1" aria-label="Diminuir quantidade">−</button>' +
                '<span>' + it.quantity + '</span>' +
                '<button type="button" data-cd-qty="1" aria-label="Aumentar quantidade">+</button>' +
              '</div>' +
              '<span class="cd-item__price">' + old + money(it.final_line_price) + '</span>' +
            '</div>' +
            '<button type="button" class="cd-item__remove" data-cd-remove>Remover</button>' +
          '</div>' +
        '</li>';
    }).join('');

    subtotalEl.textContent = money(cart.total_price);
    return cart;
  }

  function showError(msg) {
    errorEl.textContent = msg;
    errorEl.hidden = false;
    setTimeout(function () { errorEl.hidden = true; }, 5000);
  }

  function refresh() {
    return fetch('/cart.js', { headers: { 'Accept': 'application/json' }, cache: 'no-store' })
      .then(jsonOrThrow)
      .then(render)
      .catch(function () {});
  }

  function change(key, qty, li) {
    if (li) li.classList.add('is-loading');
    noticeEl.hidden = true;
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    })
      .then(jsonOrThrow)
      .then(render)
      .catch(function (err) {
        if (li) li.classList.remove('is-loading');
        showError((err && (err.description || err.message)) || 'Não foi possível atualizar o carrinho.');
        refresh();
      });
  }

  /* ---------- Abrir / fechar ---------- */
  function open(justAdded) {
    clearTimeout(closeTimer);
    noticeEl.hidden = !justAdded;
    drawer.hidden = false;
    void drawer.offsetWidth;
    drawer.classList.add('is-open');
    document.documentElement.classList.add('cd-lock');
    var closeBtn = drawer.querySelector('.cart-drawer__close');
    if (closeBtn) closeBtn.focus({ preventScroll: true });
  }
  function close() {
    drawer.classList.remove('is-open');
    document.documentElement.classList.remove('cd-lock');
    closeTimer = setTimeout(function () { drawer.hidden = true; }, 320);
  }

  /* ---------- Adicionar ao carrinho ---------- */
  function addFromForm(form, btn) {
    var fd = new FormData(form);
    btn.classList.add('is-loading');
    btn.disabled = true;
    errorEl.hidden = true;
    fetch('/cart/add.js', { method: 'POST', headers: { 'Accept': 'application/json' }, body: fd })
      .then(jsonOrThrow)
      .then(function () { return refresh(); })
      .then(function () { open(true); })
      .catch(function (err) {
        refresh();
        open(false);
        showError((err && (err.description || err.message)) || 'Não foi possível adicionar o produto.');
      })
      .then(function () {
        btn.classList.remove('is-loading');
        btn.disabled = false;
      });
  }

  /* Captura (fase de captura no window): roda antes do theme.js e de scripts de apps */
  window.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;

    // Botão "Adicionar ao carrinho" (qualquer submit de form /cart/add que não seja o "Comprar agora")
    var btn = t.closest('form[action*="/cart/add"] button[type="submit"], form[action*="/cart/add"] input[type="submit"]');
    if (btn && btn.getAttribute('name') !== 'buy-now' && !btn.disabled) {
      e.preventDefault();
      e.stopPropagation();
      addFromForm(btn.form, btn);
      return;
    }

    // Ícone do carrinho no cabeçalho → abre a gaveta
    var cartLink = t.closest('.site-header__cart, [data-cart-open]');
    if (cartLink && !isCartPage) {
      e.preventDefault();
      e.stopPropagation();
      refresh();
      open(false);
    }
  }, true);

  /* Cliques dentro da gaveta */
  drawer.addEventListener('click', function (e) {
    var t = e.target;
    if (t.closest('[data-cd-close]')) { e.preventDefault(); close(); return; }

    var li = t.closest('.cd-item');
    if (!li) return;
    var key = li.getAttribute('data-key');
    var qty = parseInt(li.getAttribute('data-qty'), 10) || 0;

    var q = t.closest('[data-cd-qty]');
    if (q) {
      var delta = parseInt(q.getAttribute('data-cd-qty'), 10) || 0;
      change(key, Math.max(0, qty + delta), li);
      return;
    }
    if (t.closest('[data-cd-remove]')) {
      change(key, 0, li);
    }
  });

  checkoutEl.addEventListener('click', function () {
    checkoutEl.classList.add('is-loading');
    var label = checkoutEl.querySelector('span');
    if (label) label.textContent = 'Indo para o pagamento...';
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && drawer.classList.contains('is-open')) close();
  });

  // Volta do checkout pelo botão "voltar" do navegador: reseta o botão e atualiza
  window.addEventListener('pageshow', function (e) {
    if (e.persisted) {
      checkoutEl.classList.remove('is-loading');
      var label = checkoutEl.querySelector('span');
      if (label) label.textContent = 'Finalizar compra';
      refresh();
    }
  });

  /* Estado inicial do contador */
  setCount(parseInt(window.NutriCartInitialCount, 10) || 0);

  window.NutriCart = { open: function () { refresh(); open(false); }, close: close, refresh: refresh };
})();
